import React from 'react'
import { useStyle } from "./Style";
import { Grid } from '@mui/material';

const ClaimSummary = (props) => {
  const classes = useStyle();
  console.log("claim summary props", props);

  if (!props.claimSummaryData) return (
    <>
      <Grid container spacing={2} className={classes.headingclaim}>
        <Grid item xs={12} sm={12} md={12}>
          <h4>Claim Details</h4>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <p>nothing found yet</p>
        </Grid>
      </Grid>
    </>
  )
  return (
    <>
      <Grid container spacing={2} className={classes.headingclaim}>
        <Grid item xs={12} sm={12} md={12}>
          <h4>Claim Summary</h4>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>

          {
            (props.hasHospiCashIllnessBenefit) ||  (props.hasHospiCashAccidentBenefit)  ? (<>

              <div className={classes.claimDetailsWrapper}>
                <table>
                  <tr>
                    <th>Policy  Number</th>
                    <th>Admission Date</th>
                    <th>Discharge Date</th>
                    <th>Number Of Days In Hospital</th>
                    <th>Hospital Attended</th>
                    <th>Inpatient Number</th>
                    <th>Cause Of Hospitilization</th>
                  </tr>
                  <tr >
                    <td>{props.claimSummaryData.policy_number}</td>
                    <td>{props.claimSummaryData.additional_details.admission_date || "N/A"}</td>
                    <td>{props.claimSummaryData.additional_details.discharge_date || "N/A"}</td>
                    <td>{props.claimSummaryData.additional_details.number_of_days_in_hospital || "N/A"}</td>
                    <td>{props.claimSummaryData.additional_details.hospital_attended || "N/A"}</td>
                    <td>{props.claimSummaryData.additional_details.inpatient_number || "N/A"}</td>
                    <td>{props.claimSummaryData.additional_details.cause_of_hospitilization || "N/A"}</td>
                  </tr>
                </table>


              </div>
            </>) : (props.hasAccidentalDeathBenefits) && props.typeOfClaim === "Accidental Death" ? (<>

              <div className={classes.claimDetailsWrapper}>
                <table>
                  <tr>
                    <th>Policy  Number</th>
                    <th>Date Of Death</th>
          
                  </tr>
                  <tr >
                    <td>{props.claimSummaryData.policy_number}</td>
                    <td>{props.claimSummaryData.event_date || "N/A"}</td>
                  </tr>
                </table>


              </div>


            </>) :  (props.hasAccidentalDeathBenefits) && props.typeOfClaim === "Accidental Disability" ? (<>

              <div className={classes.claimDetailsWrapper}>
                <table>
                  <tr>
                    <th>Policy  Number</th>
                    <th>Date Of Disability</th>
                    <th>Type of Disability</th>
                    <th>Attending Physician</th>
          
                  </tr>
                  <tr >
                    <td>{props.claimSummaryData.policy_number}</td>
                    <td>{props.claimSummaryData.event_date || "N/A"}</td>
                    <td>{props.claimSummaryData.additional_details.type_of_disability || "N/A"}</td>
                    <td>{props.claimSummaryData.additional_details.attending_physician || "N/A"}</td>
                  </tr>
                </table>


              </div>


            </>) : props.hasRoadsideAssistanceBenefit ?   (
            <>
            <div className={classes.claimDetailsWrapper}>
                <table>
                  <tr>
                    <th>Policy Number</th>
                    <th>Car Registration</th>
                    <th>Incident Date</th>
                    <th>Location</th>
                    <th>Time of Incident</th>
                    <th>Assistance Type</th>
                  
                  </tr>
                  <tr >
                    <td>{props.claimSummaryData.policy_number}</td> 
                    <td>{props.claimSummaryData.additional_details.car_registration || "N/A"}</td>
                    <td>{props.claimSummaryData.event_date || "N/A" }</td>
                    <td>{props.claimSummaryData.additional_details.incident_location || "N/A" }</td>
                    <td>{props.claimSummaryData.additional_details.incident_time || "N/A" }</td>
                    <td>{props.claimSummaryData.additional_details.assistance_type || "N/A" }</td>

                  </tr>
                </table>


              </div>

            </>)   
            : props.hasLegalCoverBenefit || props.hasBDFandPrisonsBenefit ? (<>
              <div className={classes.claimDetailsWrapper}>
                <table>
                  <tr>
                    <th>Policy  Number</th>
                    <th>Incident Date</th>
                    <th>Nature Of Case</th>
                    <th>Type Of Dispute</th>
                    <th>Brief Description</th>
                  </tr>
                  <tr >
                    <td>{props.claimSummaryData.policy_number}</td>
                    <td>{props.claimSummaryData.event_date || "N/A"}</td>
                    <td>{props.claimSummaryData.additional_details.nature_of_case || "N/A"}</td>
                    <td>{props.claimSummaryData.additional_details.type_of_dispute || "N/A"}</td>
                    <td>{props.claimSummaryData.additional_details.brief_description || "N/A"}</td>
                  </tr>
                </table>
                </div>
            </> )
             : (
            <>

              <div className={classes.claimDetailsWrapper}>
                <table>
                  <tr>
                    <th>Policy  Number</th>
                    <th>Admission Date</th>
                    <th>Discharge Date</th>
                    <th>Number of Days in Hospital</th>
                    <th>Hospital Attended</th>
                    <th>Inpatient Number</th>
                    <th>Type of Cancer</th>
                  </tr>
                  <tr >
                    <td>{props.claimSummaryData.policy_number}</td>
                    <td>{props.claimSummaryData.additional_details.admission_date || "N/A"}</td>
                    <td>{props.claimSummaryData.additional_details.discharge_date || "N/A" }</td>
                    <td>{props.claimSummaryData.additional_details.number_of_days_in_hospital || "N/A" }</td>
                    <td>{props.claimSummaryData.additional_details.hospital_attended || "N/A" }</td>
                    <td>{props.claimSummaryData.additional_details.inpatient_number || "N/A"}</td>
                    <td>{props.claimSummaryData.additional_details.type_of_cancer || "N/A" }</td>
                  </tr>
                </table>


              </div>
            
            
            
            </>)
          }


        </Grid>
      </Grid>
    </>
  )
}

export default ClaimSummary